var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRf5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "url(#pattern0_874_650)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_874_650",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_874_650",
    transform: "scale(0.0222222 0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_874_650",
    width: 45,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAwCAQAAAAvWztUAAADo0lEQVRYw91XW0gVURQda83cm3Qre5oalGGkmNSHGlZCCUZBVPQkrMjoJRKVUhBhmBUFaQ/CXhD1EREUFEJE1k9ClmAvyl5EkQmlSfbQosxpzXjVucd5Xvzq7I87s/fa6545j33WkSTLFjkAM7EC2diIO/iMVjxHGTIwF8uQlt5PCrcpCkrwFaqlvceqsIjhw22d4Cku4wFeIU+Ox2A5HefwE7W4gtd69Kh34um4y8RmzOkdUyOCmOX4QcxleaIX4qN6j34jywG3BH+Ja0eeW+LdOrxYjnXGyuNQig7aUjeTNxptpF7o4RvXE//WLzsDCwi87nFmapiT7Qw7S1iBR+oDzNniDLtKWK5H6h3MKXKGHdQGZFR/T1vrHnPmu5nzFgIf4xROhthhJBtQiTiBC7pdxBvi6/yRbj4vx2Jj1xowN4RYsruRSyW0BStDLJ++JgPmMd+3YYFu3JOK4p76ozCe0SbUU4LPX/5Lahb9RdiPM7SrfUqNNLwMmXGBWh6mTa0B/4zvKS6oMYqHk4oPXLuFtJLe1MQ00zsh+EcB/MKfgN8N9Wltk/iHBBNjTanP03vHFyVJ/khc4vPt7ogt9XNC53V/vDl1HBrpb0W1RsXfBHfUPCvksfbU9MfzVO+ciWokGbJtqTX4mG6KGHPqzgojZ8rDhey+oTbN/g+pG0iW6jSNJiOfieN4wvNcxQtW7vVyoDf1NQbLvVFjPNeJWNG/o1joP6ZSd3RQ2CT7onxRSHKmpnL6RlQjVUgWz6URSME6VOr0TxAXCt1MrWRTQwTiPB1TKg4AZuhK8J1ALk9mzXuAetone2pMoqD8ixyzmDJUH6Yqi2PbrF4boj5qVxU7DZ7ZONJDhZHsnIpN4VCvYvSZsVeooictZB6ovQMwn3uWHyvNj1uMrg7xaCpkWs+7GqHLhxnm6c1WCioAnt/tylA7anrK6Cm2XgEduEn9J5pWqesFtEZdTnGWj0FBz1p6zptS85OKhMVotIcCdWV3ZE3QM5/PFdabOJbH8NZepn3qewGZiF3sShGjXb3OJeqc5K0pA/EH7V1HneUqOkTqPZLXhvtMy3HAvLZcIbZpG7Q6YXcdxWIiGsK4sFIKaSW40HKOhrGGqNgghdN4jdZuaEtMY4P0o7nGdC+6It+lr/u9olynBqvTBkOOkcJv2M6VQhLsQ4YSTTWVQA1e0Vmve2RHuOQZ+pUu1NqwXxko9UXDLBzDIzRRS73hFSRfiRYR/wD3vMp+gp8hDwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf5);
export default __webpack_public_path__ + "static/media/rf5.4e1a4a016f25cb8292ae8bdaf74f6dce.svg";
export { ForwardRef as ReactComponent };